@if (config) {
    @if (loading$$()) {
        <div class="nw-hero-block__loader">
            <nw-logo-loading [color]="!mediaOnly ? '#fff' : '#333'"></nw-logo-loading>
        </div>
    } @else {
        <section
            class="nw-hero-block__container"
            [class.nw-hero-block__container--right]="
                config.layout === 'right' && !mediaOnly
            "
            [class.nw-hero-block__container--light]="
                config.scheme === 'light' && !mediaOnly
            "
            [style.height.px]="dimensions$$().height"
        >
            @if (!mediaOnly) {
                @if (config.media && config.media.type === 'image' && config.media.path) {
                    <div
                        #media
                        class="nw-hero-block__container__backdrop"
                        [style.backgroundImage]="
                            'url(&quot;' + config.media.path + '&quot;)'
                        "
                    ></div>
                }

                @if (config.media && config.media.type === 'video') {
                    <video
                        #media
                        class="nw-hero-block__container__video"
                        autoplay
                        loop
                        muted
                        playsinline
                        disablepictureinpicture
                        disableremoteplayback
                        x-webkit-airplay="deny"
                        [poster]="config.media.poster"
                        width="100%"
                        height="100%"
                        controlsList="nodownload"
                        [attr.id]="config.id + 'video'"
                        [style.maxHeight.px]="dimensions$$().height"
                    >
                        <source [src]="config.media.path" type="video/mp4" />
                    </video>
                }
            }
            <div
                #content
                class="nw-hero-block__container__content"
                [class.nw-hero-block__container__content--media-only]="mediaOnly"
            >
                @if (!mediaOnly) {
                    <div
                        #contentText
                        class="nw-hero-block__container__content__text"
                        [class.nw-hero-block__container__content__text--carousel-left]="
                            config.carousel?.length && config.layout === 'left'
                        "
                        [class.nw-hero-block__container__content__text--carousel-right]="
                            config.carousel?.length && config.layout === 'right'
                        "
                    >
                        @if (config.image) {
                            <img
                                class="nw-hero-block__container__content__text__top-image"
                                [ngSrc]="config.image.path"
                                [alt]="config.image.alt || ''"
                                width="282"
                                height="51"
                            />
                        }
                        @if (config.title; as title) {
                            @if (title.content) {
                                @switch (title.type || 1) {
                                    @case (1) {
                                        <h1
                                            [innerHTML]="title.content | highlightText"
                                        ></h1>
                                    }
                                    @case (2) {
                                        <h2
                                            [innerHTML]="title.content | highlightText"
                                        ></h2>
                                    }
                                    @case (3) {
                                        <h3
                                            [innerHTML]="title.content | highlightText"
                                        ></h3>
                                    }
                                }
                            }
                        }
                        @if (config.content; as content) {
                            @if (config.title?.content && !config.image) {
                                <div
                                    class="nw-hero-block__container__content__text__underline margin-bottom-l margin-top-l"
                                ></div>
                            }
                            <div
                                class="nw-hero-block__container__content__text__content"
                                [class.margin-top-l]="config.title?.content"
                                [innerHTML]="content.content | sanitizeHtml"
                            ></div>
                            @if (content.button && content.button.label) {
                                <a
                                    [href]="content.button.path"
                                    class="nw-button nw-button--primary nw-button--m margin-top-xl"
                                >
                                    <span
                                        [innerHTML]="content.button.label | sanitizeHtml"
                                    ></span>
                                </a>
                            }
                        }
                    </div>
                    <div
                        class="nw-hero-block__container__content__media"
                        [class.nw-hero-block__container__content__media--carousel]="
                            config.carousel?.length
                        "
                    >
                        @if (config.sideText || config.sideTextSub) {
                            <div
                                class="nw-hero-block__container__content__media__side-text"
                                [class.nw-hero-block__container__content__media__side-text--black]="
                                    config.sideTextColor === 'black'
                                "
                            >
                                @if (config.sideText) {
                                    <p [innerHTML]="config.sideText | sanitizeHtml"></p>
                                }
                                @if (config.sideTextSub) {
                                    <p
                                        [innerHTML]="config.sideTextSub | sanitizeHtml"
                                    ></p>
                                }
                            </div>
                        }
                        @if (config.media && config.media.type === 'image') {
                            <img
                                class="nw-hero-block__container__content__media__image"
                                #media
                                [ngSrc]="config.media.path"
                                [alt]="config.media.alt"
                                height="640"
                                width="1280"
                                priority
                            />
                        }
                        @if (config.media && config.media.type === 'video') {
                            <video
                                #media
                                autoplay
                                loop
                                muted
                                playsinline
                                disablepictureinpicture
                                disableremoteplayback
                                x-webkit-airplay="deny"
                                [poster]="config.media.poster"
                                width="100%"
                                height="100%"
                                controlsList="nodownload"
                                [attr.id]="config.id + 'video'"
                                [style.filter]="
                                    config.media.tint && config.media.tint !== 'none'
                                        ? 'url(#tint)'
                                        : undefined
                                "
                            >
                                <source [src]="config.media.path" type="video/mp4" />
                            </video>
                        }
                        @if (config.carousel?.length) {
                            <div
                                class="nw-hero-block__container__content__media__carousel"
                            >
                                <nw-carousel-block
                                    [config]="config.carousel!"
                                ></nw-carousel-block>
                            </div>
                        }
                    </div>
                }
                @if (mediaOnly && config.media) {
                    @if (config.media.type === 'image') {
                        <img
                            class="nw-hero-block__container__content__media__image"
                            #media
                            [ngSrc]="config.media.path"
                            [alt]="config.media.alt"
                            height="640"
                            width="1280"
                            priority
                        />
                    }
                    @if (config.media.type === 'video') {
                        <video
                            #media
                            autoplay
                            loop
                            muted
                            playsinline
                            disablepictureinpicture
                            disableremoteplayback
                            x-webkit-airplay="deny"
                            [poster]="config.media.poster"
                            width="100%"
                            [attr.height]="dimensions$$().height"
                            controlsList="nodownload"
                            [attr.id]="config.id + 'video'"
                            [style.filter]="
                                config.media.tint && config.media.tint !== 'none'
                                    ? 'url(#tint)'
                                    : undefined
                            "
                        >
                            <source [src]="config.media.path" type="video/mp4" />
                        </video>
                    }
                }
            </div>
        </section>
    }
}
